module.exports = __webpack_public_path__ + "img/rejaile.8453ba15.png";